export default __webpack_public_path__ + "static/media/new_in_town.0d47f7ab.webm";